/**
 * ImpostorView.js
 *
 * Renders the impostor interface with a textbox and submit button.
 */

import React, { useState } from "react";
import { submitImpostorGuess } from "../helpers/impostorWordGameHelpers";

const ImpostorView = ({ roomID, user, team }) => {
    const [guess, setGuess] = useState("");
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async () => {
        await submitImpostorGuess(roomID, user, team, guess);
        setSubmitted(true);
    };

    return (
        <div className="flex flex-col items-center justify-center text-center">
            <p className="text-zinc-400 text-lg mb-3">Guess the Movie 👀</p>
            {submitted ? (
                <p className="text-green-400 text-lg">✅ Guess Submitted!</p>
            ) : (
                <div className="flex flex-col items-center gap-4">
                    <input
                        type="text"
                        value={guess}
                        onChange={(e) => setGuess(e.target.value)}
                        placeholder="Enter your guess..."
                        className="px-4 py-2 rounded-md w-64 text-black focus:outline-none"
                    />
                    <button
                        onClick={handleSubmit}
                        className="px-6 py-2 bg-sky-500 rounded-md text-white hover:bg-sky-600 transition"
                    >
                        Submit Guess
                    </button>
                </div>
            )}
        </div>
    );
};

export default ImpostorView;